// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--rc5x1","content":"_1410bfd27b--content--gwAHz","image":"_1410bfd27b--image--mCOhW","title":"_1410bfd27b--title--i9ctw"};